import api from "../../plugins/api";
import { logger } from "../services/LoggerService";
export class ApiUserRepository {
    async createAdyenLink() {
        try {
            const response = await api.get("/payment-manager/onboard-link");
            /* response.data example (tokens elided):
              {
                "success": true,
                "errorCode": "None",
                "message": "Onboarding link created successfully",
                "result": {
                  "onboardingUrl": "https://onboarding-test.adyen.com/onboardingcomponents/ho/v1/<token>/legalEntities/<legalEntityId>?signature=<signature>&locale=fr-FR",
                  "legalEntityId": "LE00000000000000000000000",
                  "returnUrl": "",
                  "createdAt": "2025-07-25T15:23:30.9755973Z"
                },
                "errorResult": null
              }
      
              Adyen-owned shape, passed through untouched; see onboarding.integration.spec.ts (OP-7552)
            */
            return response.data.result.onboardingUrl;
        }
        catch (error) {
            logger.debug("Error creating Adyen link:", error);
            throw error;
        }
    }
    async updateUserLocale(locale) {
        try {
            // Use BFF API to update user locale in Keycloak
            await api.put("/users/locale", { locale }, { apiType: "bff" } // Specify to use BFF API
            );
            /* response.data example:
              {
                "success": true,
                "errorCode": "None",
                "message": "User locale updated successfully",
                "result": null,
                "errorResult": null
              }
            */
            logger.debug(`User locale updated to: ${locale}`);
        }
        catch (error) {
            logger.debug("Error updating user locale:", error);
            throw error;
        }
    }
}
